import React, { useState, useEffect } from 'react';
import { useDisciplinasLazyQuery } from '../graphql/queries/disciplinas.query';
import { DisciplinasQuery_disciplinas } from '../graphql/queries/__generated__/DisciplinasQuery';
import { useCadastrarDisciplinaMutation } from '../graphql/mutations/cadastrar_disciplina.mutation';
import { useDeletarDisciplinaMutation } from '../graphql/mutations/deletar_disciplina.mutation';
import { useEditarDisciplinaMutation } from '../graphql/mutations/editar_disciplina.mutation';
import { FormDisciplina, FormularioDisciplina } from '../components/form_disciplina';
import { FormList } from '../../shared/components/form_components/list';
import { Container } from '../../shared/components/layout_components/container/styles';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';

const DisciplinaPage: React.FC = () => {
  const [disciplina, setDisciplina] = useState<FormDisciplina>();
  const [disciplinas, setDisciplinas] = useState<DisciplinasQuery_disciplinas[]>([]);
  const [termoBusca, setTermoBusca] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itens_por_pagina = 25;

  const [obter_disciplinas, { fetchMore, loading }] = useDisciplinasLazyQuery();
  const [cadastar_disciplina] = useCadastrarDisciplinaMutation();
  const [editar_disciplina] = useEditarDisciplinaMutation();
  const [deletar_disciplina] = useDeletarDisciplinaMutation();

  const on_submit = async (disciplina: FormDisciplina) => {
    if (!disciplina.id_disciplina) {
      const { data } = await cadastar_disciplina({
        variables: {
          ...disciplina,
        },
      });

      if (data) {
        setDisciplinas([...disciplinas, data.cadastrarDisciplina]);

        alert('Disciplina cadastrada com sucesso!');
      }
    } else {
      const { data } = await editar_disciplina({
        variables: {
          ...disciplina,
          id_disciplina: disciplina.id_disciplina,
        },
      });

      if (data) {
        const index = disciplinas.findIndex(
          (disciplina) => disciplina.id_disciplina === data.editarDisciplina.id_disciplina
        );

        if (index !== -1) {
          const disciplinas_atualizadas = [...disciplinas];
          disciplinas_atualizadas[index] = data.editarDisciplina;
          setDisciplinas(disciplinas_atualizadas);
        }

        alert('Disciplina editada com sucesso!');
      }
    }

    setDisciplina(undefined);
  };

  const on_edit = (disciplina: DisciplinasQuery_disciplinas) => {
    setDisciplina({
      id_disciplina: disciplina.id_disciplina,
      dsc_ementa: disciplina.dsc_ementa || '',
      dsc_nome_disciplina: disciplina.dsc_nome_disciplina || '',
      dsc_sigla: disciplina.dsc_sigla || '',
      num_carga_horaria: disciplina.num_carga_horaria || 0,
    });
  };

  const on_delete = async (id_disciplina: number) => {
    await deletar_disciplina({ variables: { id_disciplina } });
    setDisciplinas((disciplinas) => disciplinas.filter((d) => d.id_disciplina !== id_disciplina));
  };

  const on_cancel_edit = () => {
    setDisciplina(undefined);
  };

  const obter_mais_dados = async (descricao = '', pagina = 1) => {
    const { data } = await fetchMore({
      variables: {
        descricao,
        pagina,
        itens_por_pagina,
      },
    });

    if (data && pagina > 1) {
      setDisciplinas([...disciplinas, ...data.disciplinas]);
    } else {
      setDisciplinas(data.disciplinas);
    }
  };

  const dados_dados_iniciais = async () => {
    const { data } = await obter_disciplinas({
      variables: {
        descricao: '',
        pagina: 1,
        itens_por_pagina,
      },
    });

    if (data) {
      setDisciplinas(data.disciplinas);
    }
  };

  const proxima_pagina = () => {
    setPaginaAtual((paginaAtual) => paginaAtual + 1);
  };

  useEffect(() => {
    obter_mais_dados(termoBusca);
  }, [termoBusca]);

  useEffect(() => {
    obter_mais_dados(termoBusca, paginaAtual);
  }, [paginaAtual]);

  useEffect(() => {
    document.title = 'SisIEC - Disciplinas';
    dados_dados_iniciais();
  }, []);

  return (
    <Container>
      <SubContainer flex={1}>
        <FormularioDisciplina
          onSubmit={on_submit}
          onCancel={on_cancel_edit}
          disciplina={disciplina}
        />
      </SubContainer>

      <SubContainer flex={2}>
        <FormList
          list_name='Disciplinas'
          items={disciplinas.map((d) => ({
            data: d,
            id: d.id_disciplina,
            label:
              (d.dsc_nome_disciplina || '') +
              ' - ' +
              (d.dsc_sigla || '') +
              ' - ' +
              (d.num_carga_horaria || 0) +
              ' horas',
          }))}
          onSearch={setTermoBusca}
          onScroll={proxima_pagina}
          onEdit={on_edit}
          onDelete={on_delete}
          loading={loading}
        />
      </SubContainer>
    </Container>
  );
};

export { DisciplinaPage };
